
<template>
  <div class="EIA-page" :class="{ 'col-10': !isMobile }">
    <!-- Mobile Header -->
    <div class="mobile-header" v-if="isMobile">
      <div class="mobile-header-content">
        <h1 class="mobile-title">EIA Impacts</h1>
        <div class="mobile-menu" @click="toggleMobileNav">
          <div class="hamburger-icon">
            <span></span>
            <span></span>
            <span></span>
          </div>
          <span class="menu-text">MENU</span>
        </div>
      </div>
    </div>

    <!-- Mobile Navigation Panel -->
    <div class="mobile-nav-overlay" v-if="isMobile && isMobileNavOpen" @click="closeMobileNav"></div>
    <div class="mobile-nav-panel" :class="{ 'nav-open': isMobileNavOpen }" v-if="isMobile">
      <div class="nav-close-btn" @click="closeMobileNav">×</div>
      <div class="nav-content">
        <router-link to="/" @click="closeMobileNav" class="nav-item" :class="{ active: $route.name === 'Home' }">
          <img src="/icons/home.svg" alt="Home" /> Home
        </router-link>
        <router-link to="/project-info" @click="closeMobileNav" class="nav-item" :class="{ active: $route.name === 'ProjectInfo' }">
          <img src="/icons/info.svg" alt="Project Info" /> Project Info
        </router-link>
        <router-link to="/eia" @click="closeMobileNav" class="nav-item" :class="{ active: $route.name === 'EIA' }">
          <img src="/icons/data.svg" alt="Environmental Impacts" /> Environmental Impacts
        </router-link>
        <router-link to="/3d" @click="closeMobileNav" class="nav-item" :class="{ active: $route.name === 'Model' }">
          <img src="/icons/3d.svg" alt="3D Navigation" /> 3D Navigation
        </router-link>
        <div class="nav-footer">
          <div class="footer-title">Development of Lok Ma Chau Loop</div>
          <div class="footer-subtitle">Eastern Connection Road</div>
          <div class="footer-disclaimer">Disclaimer</div>
        </div>
      </div>
    </div>

    <!-- Responsive SidePanelEIA (works on both desktop and mobile) -->
    <SidePanelEIA />

    <LeafletMap
      class="main"
      :class="{ hide: !sceneManager.mapShow }"
    ></LeafletMap>
    <tour class="main" :mediaIndex="2"></tour>
  </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from "vue";
import LeafletMap from "@/components/leaflet-map.vue";
import tour from "@/components/tour.vue";
import SidePanelEIA from "@/components/SidePanelEIA.vue";
import { sceneManager } from "@/store/sceneManager";

// Mobile state
const isMobile = ref(false);
const isMobileNavOpen = ref(false);

// Check if mobile
const checkMobile = () => {
  isMobile.value = window.innerWidth <= 768;
};

// Mobile navigation methods
const toggleMobileNav = () => {
  isMobileNavOpen.value = !isMobileNavOpen.value;
};

const closeMobileNav = () => {
  isMobileNavOpen.value = false;
};

onMounted(() => {
  checkMobile();
  window.addEventListener("resize", checkMobile);
});

onUnmounted(() => {
  window.removeEventListener("resize", checkMobile);
});
</script>

<style scoped>
.EIA-page {
  /* position: relative; */
  padding: 12vh 0 0 0;
  /* top: 12vh; */
  height: 100%;
  margin: 0;
  border: none;
  overflow: hidden !important;
  /* height: 88vh; */
}

.main {
  height: 100%;
  width: 100%;
  padding: 0;
  margin: 0;
  border: none;
}

leaflet-map {
  /* height: 100%; */
  /* width: 100%; */
  padding: 0;
  margin: 0;
  border: none;
  /* transition: transform 0.5s ease-in-out; */
}

/* fix scroll */
body {
  /* overflow: hidden; */
}

.hide {
  display: none;
  /* transform: translateX(-100%); */
}

/* Mobile Header */
.mobile-header {
  display: none;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 60px;
  background-color: #00353e;
  z-index: 1000;
  padding: 0 20px;
}

.mobile-header-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 100%;
}

.mobile-title {
  color: white;
  font-size: 18px;
  font-weight: bold;
  margin: 0;
  font-family: Arial, Helvetica, sans-serif;
}

.mobile-menu {
  display: flex;
  flex-direction: column;
  align-items: center;
  color: white;
  cursor: pointer;
}

.hamburger-icon {
  display: flex;
  flex-direction: column;
  gap: 3px;
  margin-bottom: 2px;
}

.hamburger-icon span {
  width: 20px;
  height: 2px;
  background-color: white;
  border-radius: 1px;
}

.menu-text {
  font-size: 10px;
  font-family: Arial, Helvetica, sans-serif;
}

/* Mobile Navigation Panel */
.mobile-nav-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1001;
}

.mobile-nav-panel {
  position: fixed;
  top: 0;
  right: -100%;
  width: 70%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.95);
  border-radius: 20px 0 0 20px;
  transition: right 0.3s ease-in-out;
  z-index: 1002;
  overflow: hidden;
}

.mobile-nav-panel.nav-open {
  right: 0;
}

.nav-close-btn {
  position: absolute;
  top: 20px;
  right: 20px;
  width: 30px;
  height: 30px;
  background-color: #00353e;
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  cursor: pointer;
  z-index: 1003;
}

.nav-content {
  padding: 80px 30px 30px 30px;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.nav-item {
  display: flex;
  align-items: center;
  padding: 15px 0;
  text-decoration: none;
  color: #333;
  font-family: Arial, Helvetica, sans-serif;
  font-size: 16px;
  border-bottom: 1px solid #eee;
  transition: background-color 0.3s ease;
}

.nav-item:hover {
  background-color: #f5f5f5;
}

.nav-item.active {
  background-color: #008768;
  color: white;
}

.nav-item img {
  width: 20px;
  height: 20px;
  margin-right: 15px;
}

.nav-item.active img {
  filter: brightness(0) invert(1);
}

.nav-footer {
  margin-top: auto;
  padding-top: 30px;
  text-align: center;
}

.footer-title {
  font-size: 14px;
  color: #666;
  margin-bottom: 5px;
  font-family: Arial, Helvetica, sans-serif;
}

.footer-subtitle {
  font-size: 18px;
  font-weight: bold;
  color: #00353e;
  margin-bottom: 10px;
  font-family: Arial, Helvetica, sans-serif;
}

.footer-disclaimer {
  font-size: 12px;
  color: #999;
  text-decoration: underline;
  cursor: pointer;
  font-family: Arial, Helvetica, sans-serif;
}

/* Mobile responsive styles */
@media screen and (max-width: 768px) {
  .EIA-page {
    padding-top: 60px; /* Adjust for mobile header */
    width: 100% !important;
    max-width: 100% !important;
  }
  
  .mobile-header {
    display: block;
  }
  
  .main {
    width: 100% !important;
    max-width: 100% !important;
  }
  
  leaflet-map {
    width: 100% !important;
    max-width: 100% !important;
  }
}
</style>